import isGHMC, { formattedDate, formattedDateTypeTwo, getCurrentDate, getFirstDateOfMonth } from "../../../../Common/helper/helpar";
import Modal from "react-bootstrap/Modal";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    TablePagination,
    Paper,
} from "@mui/material";

import { useEffect, useState } from "react";
import { TableLoader } from "../../../../Common/ShimmerLoader";
import { Button } from "react-bootstrap";
import { bouncy } from "ldrs";
import { useMonthWiseAttendanceStore } from "../../Attendance/MonthWiseAttendanceSummary/MonthWiseAttendanceStore";
import { FrequencyBinsInnerExport } from "./FrequencyBinsInnerExport";
bouncy.register()


const FrequencyBinsInnerReport = () => {
    const { MonthWiseAttendanceData, isLoading, fetchMonthWiseAttendanceReport, updateEmployeeAttendanceStatus, isUpdating } =
        useMonthWiseAttendanceStore();
    const [dayWiseAttendance, setDayWiseAttendance] = useState(null);
    const currentDate = getCurrentDate();
    const [formSubmitted, setFormSubmitted] = useState(false);

    const [formData, setFormData] = useState({
        FromDate: "",
        ToDate: "",
    });

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form default submission
        setFormSubmitted(true);
        let validationErrors = {};
        if (!formData.attendanceStatus) {
            validationErrors.attendanceStatus = "Current Status is required";
        }
        if (!formData.punchInTime) {
            validationErrors.punchInTime = "Punch In Time is required";
        }

        // If there are errors, update state and stop submission
        if (Object.keys(validationErrors).length > 0) {

            return;
        }


        const formatTimeToISO = (dateTime) => {
            if (!dateTime) return null; // Handle empty values
            return new Date(dateTime).toISOString();
        };
        const payload = {
            ...formData,
            attendanceDate: formatTimeToISO(dayWiseAttendance),
            punchInTime: formData.punchInTime,
            punchOutTime: formData.punchOutTime ? formData.punchOutTime : null,
        };

        const queryString = {
            FromDate: getFirstDateOfMonth(),
            ToDate: currentDate,
        };
        try {
            const response = await updateEmployeeAttendanceStatus(payload);
            console.log("Success:", response);
            setFormData({
                attendanceStatus: "",
                description: "",
                punchInTime: "",
                punchOutTime: "",
            });
            fetchMonthWiseAttendanceReport(queryString);
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const isProd = isGHMC();
    const headerStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        color: "#fff",
        backgroundColor: isProd ? "#004554" : "#EC1117",
    };
    const cellStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        whiteSpace: "normal",
    };

    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                      <div className="top-header page-title">
                        <span>Detailed Shift Wise Data Report</span>
                      </div>
                        <FrequencyBinsInnerExport />
                        <div className="page-header text-start">
                            <div className="card">
                                <div className="card-body">
                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            width: "100%",
                                            border: "1px solid #ccc",
                                            maxHeight: 700,
                                        }}
                                    >
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead
                                                className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                                                style={{ position: "sticky", top: 0 }}
                                            >
                                                <TableRow>
                                                    <TableCell rowSpan={2} sx={headerStyles}>S.No</TableCell>
                                                    <TableCell colSpan={4} sx={headerStyles}>GVP Points</TableCell>
                                                    <TableCell colSpan={4} sx={headerStyles} style={{ textAlign: "center" }}>
                                                        Sweeping Points
                                                    </TableCell>
                                                    <TableCell colSpan={4} sx={headerStyles} style={{ textAlign: "center" }}>
                                                        Other
                                                    </TableCell>

                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={headerStyles}>Collection Point Code</TableCell>
                                                    <TableCell sx={headerStyles}>Collection Points</TableCell>
                                                    <TableCell sx={headerStyles}>Cleared</TableCell>
                                                    <TableCell sx={headerStyles}>Not Cleared</TableCell>
                                                    <TableCell sx={headerStyles}>Collection Point Code</TableCell>
                                                    <TableCell sx={headerStyles}>Collection Points</TableCell>
                                                    <TableCell sx={headerStyles}>Cleared</TableCell>
                                                    <TableCell sx={headerStyles}>Not Cleared</TableCell>
                                                    <TableCell sx={headerStyles}>Collection Point Code</TableCell>
                                                    <TableCell sx={headerStyles}>Collection Points</TableCell>
                                                    <TableCell sx={headerStyles}>Cleared</TableCell>
                                                    <TableCell sx={headerStyles}>Not Cleared</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {MonthWiseAttendanceData?.map((item, index) => (
                                                    <TableRow
                                                        key={index}
                                                        sx={{
                                                            backgroundColor: index % 2 === 1 ? "rgba(0, 69, 84, 0.04)" : "#ffffff",
                                                        }}
                                                    >
                                                        <TableCell sx={cellStyles}>{index + 1}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.date}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.hmswTonnage}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.ghmcTonnage}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.totalTonnage}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.hmswTippingFee}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.ghmcTippingFee}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.totalAmount}</TableCell>
                                                    </TableRow>
                                                ))}
                                                <TableRow>
                                                    {/* <TableCell sx={cellStyles} colSpan={2}><strong>Total</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalHMSW}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalGHMC}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalTonnage}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalHMSWTipping}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalGHMCTipping}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalAmount}</strong></TableCell> */}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    {/* </Paper> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default FrequencyBinsInnerReport;
